import { db } from '../../utils/firebase';

// get all awards
export const getAllAwards = async () => {
  const awards = [];
  const querySnapshot = await db.collection("awards").get();

  const promises = [];
  querySnapshot.forEach(doc => {
    // doc.data() is never undefined for query doc snapshots
    const { title, order } = doc.data();
    // get children for each section
    promises.push(
      db
        .collection("awards")
        .doc(title)
        .collection("children")
        .get()
    );
    awards.push({ title, order, children: [] });
  });

  // push all children to each single award section
  const snapshots = await Promise.all(promises);
  let i = 0;
  snapshots.forEach(querySnapshot1 => {
    const childrens = [];
    querySnapshot1.forEach(doc => {
      // get single children
      const { subtitle, hasList, content, year } = doc.data();
      childrens.push({
        subtitle,
        hasList,
        content: content.reverse(),
        year
      });
    });
    if (childrens.length > 0 && childrens[0].year != null) {
      awards[i].children = childrens.sort((a, b) => b.year - a.year);
    } else {
      awards[i].children = childrens;
    }
    i++;
  });

  awards.sort((a, b) => a.order - b.order);

  return awards;
}